import { useContext, useState } from "react";
import * as Scrivito from "scrivito";
import InPlaceEditingPlaceholder from "^/Components/InPlaceEditingPlaceholder";
import CookiesDeclinedBanner from "^/Components/PlaceholderWithCookieConsent";
import { CookieConsentContext } from "^/Components/CookieConsentContext";

function extractVideoID(url) {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  if (match && match[7].length === 11) {
    return match[7];
  }
  return null;
}

function PlaceholderOrYoutubeComponent({ title, videoUrl, teaser }) {
  const videoId = videoUrl.startsWith("https://")
    ? extractVideoID(videoUrl)
    : videoUrl;

  const { optionAllowed, setOptions } = useContext(CookieConsentContext);
  const [updated, setUpdated] = useState(0);

  let iframe = (
    <iframe
      title={title}
      src={`https://www.youtube-nocookie.com/embed/${videoId}`}
      allowFullScreen
    />
  );

  if (!videoId) {
    iframe = (
      <InPlaceEditingPlaceholder>
        Provide a proper YouTube video URL in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  if (!optionAllowed("youtube")) {
    const currPage = Scrivito.currentPage();
    const lang = currPage.language();
    iframe = (
      <CookiesDeclinedBanner
        icon="lab la-youtube"
        onAccept={() => {
          setOptions("youtube", true);
          setUpdated(updated + 1);
        }}
        teaser={teaser}
        lang={lang}
        serviceType="video"
      />
    );
  }

  return <figure className="youtube-video-container">{iframe}</figure>;
}

export default PlaceholderOrYoutubeComponent;
